import React from "react";
import { LegalLayout, Section } from "@/components/legal/LegalLayout";

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-[color:var(--sg-fg)] leading-relaxed">{children}</p>
);

export const CookiePolicy: React.FC = () => (
  <LegalLayout
    testId="page-cookies"
    title="Cookie Policy"
    subtitle="How SociBaba uses cookies and similar technologies."
    lastUpdated="February 13, 2026"
    seoPath="/cookies"
    seoDescription="Cookie policy for SociBaba — session tokens, localStorage keys, and CSRF-protection cookies. No third-party ad tracking."
    seoKeywords={["cookie policy","session cookies","JWT localStorage","CSRF"]}
  >
    <P>
      SociBaba uses a small number of cookies and localStorage entries strictly to keep you signed in and to remember your workspace preferences. We do not use third-party advertising or cross-site tracking cookies.
    </P>

    <Section n={1} title="What we store">
      <ul className="list-disc ml-6 space-y-2">
        <li><b>session_token</b> (HTTP-only cookie): set when you sign in with Google via Emergent Auth. Expires in 7 days.</li>
        <li><b>socibaba_token</b> (localStorage): JWT bearer token used for API requests when signing in with email/password. Cleared on logout.</li>
        <li><b>oauth_states</b> (server-side only): short-lived random tokens (15 min) that protect OAuth flows against CSRF.</li>
      </ul>
    </Section>

    <Section n={2} title="Analytics">
      <P>
        We do not embed third-party analytics scripts (no Google Analytics, no Meta Pixel). Basic server-side request logs are used for security and debugging only.
      </P>
    </Section>

    <Section n={3} title="Your choices">
      <P>
        You can clear your browser's cookies and localStorage at any time — this will sign you out. Blocking essential cookies will prevent SociBaba from working.
      </P>
    </Section>
  </LegalLayout>
);

export default CookiePolicy;
